<template>
	<div :style="yangshi">
		<div :id="ming"></div>
		<!-- <div style="position: relative;z-index: 99999;">
			<Shangchuan ref="sc" @change="Change" yangshileixing='duotu'></Shangchuan>
		</div> -->
	</div>
</template>

<script>
	// import Shangchuan from '@/zujian/shangchuan/shangchuan2.vue'
	import {
		shangwenjian
	} from '@/api/post.js';
	import E from "wangeditor"
	import i18next from "i18next";
	// let editor 

	export default {
		data() {
			return {
				xuantu: false,
				dialogFormVisible: true,
				editor: {},
				gai: 1
			}

		},
		components: {
			E,
			// Shangchuan
		},
		props: {
			ming: {
				type: String,
				default: "ming"
			},
			value: {
				type: String,
				default: ""
			},
			yangshi: {
				type: String,
				default: ''
			},
			gao: {
				type: [String, Number],
				default: 500
			}
		},
		watch: {
			value: function(a, aa) {
				if (a != aa && this.gai == 1) {
					this.editor.txt.html(this.value)
				}
			}
		},
		mounted() {
			this.TuMenu()
			// http://goodwe.jsydl.com.cn:9200/upload/file
			this.url = this.$url + "?k=wenjian";
			this.editor = new E("#" + this.ming)
			// console.log(this.editor)
			// this.editor.config.language = 'en';
			console.log(this.editor.config);
			
			this.editor.config.excludeMenus = ['emoticon', 'video', 'fontSize', 'fontName', 'head']
			this.editor.config.zIndex = 500
			this.editor.config.height = this.gao
			this.editor.config.onchange = (newHtml) => {
				if (newHtml != this.value) {
					this.gai = 0
					this.$emit("input", newHtml)
				}
			}

			this.editor.config.onblur = (newHtml) => {
				this.gai = 1
			}
			this.editor.config.onfocus = (newHtml) => {
				this.gai = 0
			}
			this.editor.config.lang = 'en';
			this.editor.config.showFullScreen = false
			this.editor.i18next = i18next;
			this.editor.config.showLinkImg = false;
			
			this.editor.config.showImgAlign=true
			// 配置图片上传服务器
			this.editor.config.uploadImgServer = 'https://community.goodwe.com/api/upload/file';
			// 配置上传文件的字段名
			this.editor.config.uploadImgParams = {
				file: null, // file字段用于接收本地图片文件
			}
			let that = this
			this.editor.config.customUploadImg = function(files, insertImgFn) {
				const formData = new FormData()
				formData.append('file', files[0])
				//其他参数根据需要自行添加 formData形式与JSON形式自行使用
				that.editor.config.uploadImgParams.file = files[0]
				const xhr = new XMLHttpRequest()
				xhr.open('POST', that.editor.config.uploadImgServer, true)
				xhr.onload = function(e) {
					if (xhr.status === 200) {
						const response = JSON.parse(xhr.responseText)
						that.editor.cmd.do("insertHTML", '<img src="https://community.goodwe.com/' + response.data +
							'" style="max-width:100%;" class="draggable-image" />');
						console.log(response.data)
					}
				}
				xhr.send(formData)
			}
			this.editor.create(() => {
				setTimeout(() => {
					this.editor.txt.html(this.value);
					this.addDragListeners(); // 确保编辑器初始化后调用
				}, 1000);
			});

			setTimeout(() => {
				this.editor.txt.html(this.value)
			}, 1000)

		},
		methods: {
			Change(e) {
				if (e && e.length > 0) {
					for (let i in e) {
						this.editor.cmd.do("insertHTML", '<img src="' + e[i] +
							'" style="display: flex;max-width:100%;" class="draggable-image" />');
						// this.editor.cmd.do('insertImage', e[i])
					}
					this.addDragListeners();
				}
			},
			addDragListeners() {
				const editorElem = this.editor.editorElem;
				const images = editorElem.querySelectorAll('.draggable-image');
				images.forEach((image) => {
					image.addEventListener('mousedown', (e) => this.startDrag(e, image));
				});
				document.addEventListener('mousemove', this.drag);
				document.addEventListener('mouseup', this.stopDrag);
			},
			startDrag(e, image) {
				this.isDragging = true;
				this.offsetX = e.clientX - image.offsetLeft;
				this.offsetY = e.clientY - image.offsetTop;
			},
			drag(e) {
				if (this.isDragging) {
					const editorElem = this.editor.editorElem;
					const images = editorElem.querySelectorAll('.draggable-image');
					images.forEach((image) => {
						image.style.left = (e.clientX - this.offsetX) + 'px';
						image.style.top = (e.clientY - this.offsetY) + 'px';
					});
				}
			},
			stopDrag() {
				this.isDragging = false;
			},
			handleAvatarSuccess(res, file) {
				let imageUrl = ''
				this.imageUrl = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('Uploading avatar images can only be in JPG format!');
				}
				if (!isLt2M) {
					this.$message.error('The size of the uploaded avatar image cannot exceed 2MB!');
				}
				return isJPG && isLt2M;
			},
			TuMenu() {
				var that = this
				const {
					$,
					BtnMenu,
					DropListMenu,
					PanelMenu,
					DropList,
					Panel,
					Tooltip
				} = E
				class TuMenu extends BtnMenu {
					constructor(editor) {
						// data-title属性表示当鼠标悬停在该按钮上时提示该按钮的功能简述
						const $elem = E.$(
							// `<div class="w-e-menu" data-title="">
				   //              <i class="w-e-icon-image"/>
				   //          </div>`
						)
						super($elem, editor)
						// setTimeout(() => {
						// 	this.updateAllMenuTitles();
						// }, 0);
						editor.config.menuConfig = {
							indent: {
								title: 'Indent',
								items: [{
										title: '设置缩进',
										value: 'set'
									},
									{
										title: '增加缩进',
										value: 'increase'
									},
									{
										title: '减少缩进',
										value: 'decrease'
									}
								]
							},
						};
					}
					// 菜单点击事件
					clickHandler() {
						that.$refs.sc.Show('duotu', 100)
						console.log(1111)
					}
					tryChangeActive(e) {

					}
					updateAllMenuTitles() {
						// 这里定义需要替换的菜单和对应的提示文本  
						// const titles = {
						// 	'上传图片': 'Upload Image'
						// };

						// 遍历所有定义的菜单  
						// Object.keys(titles).forEach((key) => {
						// 	const elements = document.querySelectorAll(`.w-e-menu[data-title="${key}"]`);
						// 	// 如果没有找到元素，输出日志以帮助调试  
						// 	if (elements.length === 0) {
						// 		// console.log(`No elements found for title: ${key}`);
						// 	}
						// 	elements.forEach((elem) => {
						// 		elem.setAttribute('data-title', titles[key]);
						// 	});
						// })
					}
				}
				E.registerMenu('Tu', TuMenu)
			}
		}
	}
</script>

<style>
	.w-e-text {
	    p{
	        b{
	            font-weight: bold !important;
	        }
	        i{
	            font-style:italic !important;
	        }
	    }
	    }
	/* .w-e-text img{display: flex;} */
</style>